import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box, Typography } from '@mui/material';

/**
 * Language switcher component for toggling between English and Norwegian.
 * Used only within the Docs page (not app-wide).
 */
const LanguageSwitcher = ({ language, onLanguageChange }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography variant="body2" color="text.secondary">
        Language:
      </Typography>
      <ToggleButtonGroup
        value={language}
        exclusive
        onChange={(e, newLang) => newLang && onLanguageChange(newLang)}
        size="small"
      >
        <ToggleButton value="en" sx={{ px: 2 }}>
          English
        </ToggleButton>
        <ToggleButton value="no" sx={{ px: 2 }}>
          Norsk
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default LanguageSwitcher;
